import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { AuthProvider } from '@src/auth/AuthContext';
import { AccountProvider } from '@src/context/AccountContext';
import { ExternalUserProvider } from '@src/context/ExternalUserContext';
import { ThemeProvider } from '@src/context/ThemeContext';
import { NetworkStatusProvider } from '@src/context/NetworkStatusContext';
import { SyncStateProvider } from '@src/context/SyncStateContext';
import { ErrorBoundary } from '@src/components/ErrorBoundary';
import { LocaleProvider } from '@src/i18n';
import { Modal } from '@7shifts/sous-chef-base';
import './styles/tokens.css';
import '@7shifts/sous-chef-base/dist/index.css';

Modal.setAppElement('#root');

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element #root not found');

createRoot(rootElement).render(
    <StrictMode>
        <ErrorBoundary>
            <ThemeProvider>
                <LocaleProvider>
                    <NetworkStatusProvider>
                        <AuthProvider>
                            <AccountProvider>
                                <SyncStateProvider>
                                    <ExternalUserProvider>
                                        <App />
                                    </ExternalUserProvider>
                                </SyncStateProvider>
                            </AccountProvider>
                        </AuthProvider>
                    </NetworkStatusProvider>
                </LocaleProvider>
            </ThemeProvider>
        </ErrorBoundary>
    </StrictMode>
);
